import script from "./ViewPendingNotificationsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewPendingNotificationsPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewPendingNotificationsPage.vue?vue&type=style&index=0&id=d0ea3646&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0ea3646"]])

export default __exports__